import * as actionTypes from "../../actions/newsletters/actionTypes";
import { updateObject } from "../../utility/utility";

const initialState = {
  error: [],
  newsletters: [],
  newsletter: [],
  loading: false,
};

export const newsletterStart = (state, action) => {
  return updateObject(state, {
    error: [],
    loading: true,
  });
};

export const getNewsletters = (state, action) => {
  return updateObject(state, {
    newsletters: action.response,
    loading: false,
  });
};

export const getNewsletter = (state, action) => {
  return updateObject(state, {
    transaction: action.response,
    loading: false,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.NEWSLETTER_START:
      return newsletterStart(state, action);
    case actionTypes.GET_NEWSLETTERS_SUCCESS:
      return getNewsletters(state, action);
    case actionTypes.GET_NEWSLETTER_SUCCESS:
      return getNewsletter(state, action);
    default:
      return state;
  }
};

export default reducer;
